export enum AuthorisedDevicesState {
    Ok = "Ok",
    RevokeError = "RevokeError",
    RevokeSuccess = "RevokeSuccess",
    LoadError = "LoadError"
}
